// extracted by mini-css-extract-plugin
export default {"container":"tk-z","bubbleNav":"uk-z","graphic":"vk-z","contact":"wk-z"};